(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sykeruns-community-video-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  const rootSelector = '[data-syk-community-reviews]';
  const findRoots = (scope) => {
    const roots = [];
    if (scope.matches && scope.matches(rootSelector)) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll(rootSelector));
    return roots;
  };

  const initialiseReviews = (scope = document) => {
    findRoots(scope).forEach((root) => {
      if (instances.has(root)) return;
      const track = root.querySelector('[data-syk-review-track]');
      if (!track) return;
      const previousButton = root.querySelector('[data-syk-review-prev]');
      const nextButton = root.querySelector('[data-syk-review-next]');
      const progress = root.querySelector('[data-syk-review-progress]');
      const thumb = root.querySelector('[data-syk-review-progress-thumb]');
      const modal = root.querySelector('[data-syk-video-modal]');
      const player = root.querySelector('[data-syk-video-player]');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const enabled = root.dataset.sykAutoplay !== 'false';
      const interval = Math.max(2500, (Number(root.dataset.sykAutoplaySpeed) || 4) * 1000);
      const events = new AbortController();
      const listen = (target, name, handler, options = {}) => {
        if (target) target.addEventListener(name, handler, { ...options, signal: events.signal });
      };
      let timer = null;
      let frame = null;
      let destroyed = false;
      let hovered = false;
      let interacting = false;
      let keyboardFocus = false;
      let selectedBlock = false;
      let inViewport = !('IntersectionObserver' in window);
      let resumeAfter = 0;
      let lastFocusedElement = null;
      const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
      const clearTimer = () => {
        if (timer !== null) window.clearTimeout(timer);
        timer = null;
      };
      const canRotate = () => enabled && !destroyed && !motion.matches &&
        !document.hidden && inViewport && !hovered && !interacting && !keyboardFocus &&
        !selectedBlock && (!modal || modal.hidden) && maxScroll() > 2;
      const cardStep = () => {
        const card = track.querySelector('.syk-community-reviews__card');
        if (!card) return track.clientWidth;
        const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      };
      const scrollTo = (left) => track.scrollTo({
        left: Math.max(0, Math.min(maxScroll(), left)),
        behavior: motion.matches ? 'auto' : 'smooth'
      });
      const schedule = () => {
        clearTimer();
        if (!canRotate()) return;
        timer = window.setTimeout(() => {
          timer = null;
          if (!canRotate()) return;
          const end = maxScroll();
          // At the last card, smoothly return to the real first card; no cloned videos.
          scrollTo(track.scrollLeft >= end - 3 ? 0 : track.scrollLeft + cardStep());
          schedule();
        }, Math.max(interval, resumeAfter - Date.now()));
      };
      const updateControls = () => {
        frame = null;
        if (destroyed) return;
        const end = maxScroll();
        const ratio = end > 0 ? Math.max(0, Math.min(1, track.scrollLeft / end)) : 0;
        if (previousButton) previousButton.disabled = track.scrollLeft <= 2;
        if (nextButton) nextButton.disabled = track.scrollLeft >= end - 2;
        if (progress && thumb) {
          const barWidth = progress.clientWidth;
          const visible = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
          const width = Math.min(barWidth, Math.max(32, barWidth * visible));
          thumb.style.width = `${width}px`;
          thumb.style.left = `${(barWidth - width) * ratio}px`;
        }
      };
      const requestUpdate = () => {
        if (frame === null) frame = window.requestAnimationFrame(updateControls);
      };
      const hold = () => {
        resumeAfter = Date.now() + Math.max(8000, interval);
        schedule();
      };
      const closeModal = (restoreFocus = true) => {
        if (!modal || modal.hidden) return;
        modal.hidden = true;
        if (player) player.replaceChildren();
        if (!document.querySelector('[data-syk-video-modal]:not([hidden])')) {
          document.body.classList.remove('syk-video-modal-open');
        }
        if (restoreFocus && lastFocusedElement && lastFocusedElement.isConnected) lastFocusedElement.focus();
        hold();
      };

      listen(track, 'scroll', () => { requestUpdate(); schedule(); }, { passive: true });
      listen(track, 'wheel', hold, { passive: true });
      listen(root, 'pointerenter', (event) => {
        if (event.pointerType === 'mouse') { hovered = true; schedule(); }
      });
      listen(root, 'pointerleave', (event) => {
        if (event.pointerType === 'mouse') { hovered = false; schedule(); }
      });
      listen(track, 'pointerdown', () => { interacting = true; clearTimer(); }, { passive: true });
      listen(window, 'pointerup', () => { if (interacting) { interacting = false; hold(); } }, { passive: true });
      listen(window, 'pointercancel', () => { if (interacting) { interacting = false; hold(); } }, { passive: true });
      // Native overflow + scroll snapping handles touch swipes; no preventDefault or click interception.
      listen(root, 'focusin', () => {
        keyboardFocus = !!(document.activeElement && document.activeElement.matches(':focus-visible'));
        schedule();
      });
      listen(root, 'focusout', (event) => {
        if (!root.contains(event.relatedTarget)) { keyboardFocus = false; schedule(); }
      });
      listen(track, 'keydown', (event) => {
        if (event.target !== track) return;
        let target;
        if (event.key === 'ArrowRight') target = track.scrollLeft + cardStep();
        else if (event.key === 'ArrowLeft') target = track.scrollLeft - cardStep();
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = maxScroll();
        else return;
        event.preventDefault();
        scrollTo(target);
        hold();
      });
      listen(previousButton, 'click', () => { scrollTo(track.scrollLeft - cardStep()); hold(); });
      listen(nextButton, 'click', () => { scrollTo(track.scrollLeft + cardStep()); hold(); });
      listen(document, 'visibilitychange', schedule);
      listen(motion, 'change', () => { updateControls(); schedule(); });

      root.querySelectorAll('[data-syk-video-id]').forEach((button) => {
        listen(button, 'click', () => {
          const id = button.dataset.sykVideoId;
          if (!id || !modal || !player) return;
          lastFocusedElement = button;
          const iframe = document.createElement('iframe');
          iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0`;
          iframe.title = button.dataset.sykVideoTitle || 'YouTube video';
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          iframe.setAttribute('allowfullscreen', '');
          player.replaceChildren(iframe);
          modal.hidden = false;
          document.body.classList.add('syk-video-modal-open');
          clearTimer();
          const close = modal.querySelector('.syk-community-reviews__close');
          if (close) close.focus();
        });
      });
      root.querySelectorAll('[data-syk-video-close]').forEach((button) => listen(button, 'click', () => closeModal()));
      listen(document, 'keydown', (event) => {
        if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
      });
      listen(root, 'shopify:block:select', (event) => {
        selectedBlock = true;
        clearTimer();
        const card = event.target.closest('.syk-community-reviews__card');
        if (card) scrollTo(track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left);
      });
      listen(root, 'shopify:block:deselect', () => { selectedBlock = false; schedule(); });

      let resizeObserver = null;
      let intersectionObserver = null;
      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(() => { requestUpdate(); schedule(); });
        resizeObserver.observe(track);
        if (progress) resizeObserver.observe(progress);
      } else {
        listen(window, 'resize', () => { requestUpdate(); schedule(); }, { passive: true });
      }
      if ('IntersectionObserver' in window) {
        intersectionObserver = new IntersectionObserver((entries) => {
          inViewport = entries.some((entry) => entry.isIntersecting);
          schedule();
        }, { threshold: 0.05 });
        intersectionObserver.observe(root);
      }
      instances.set(root, () => {
        destroyed = true;
        clearTimer();
        if (frame !== null) window.cancelAnimationFrame(frame);
        events.abort();
        if (resizeObserver) resizeObserver.disconnect();
        if (intersectionObserver) intersectionObserver.disconnect();
        closeModal(false);
        instances.delete(root);
        delete root.dataset.sykReviewsReady;
      });
      root.dataset.sykReviewsReady = 'true';
      updateControls();
      schedule();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseReviews(), { once: true });
  } else initialiseReviews();
  document.addEventListener('shopify:section:load', (event) => initialiseReviews(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    findRoots(event.target).forEach((root) => { const destroy = instances.get(root); if (destroy) destroy(); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
